







import Vue from "vue";
import store from '@/store';

export default Vue.extend({
    props: {
        item: Object,
    },

    methods: {
        admin(): boolean {
            const user = store.state.user;
            return user && user.admin;
        },

        editItem(item: any): void {
            store.dispatch('editItem', { id: item.id, editing: true });
        },

        deleteItem(item: any): void {
            if (window.confirm("Are you sure you want to delete this item?"))
                store.dispatch("deleteItem", { id: item.id });
        }
    }
});
